import axios from 'axios';

const apiUrl = process.env.REACT_APP_SERVER_URL || '/bapp';

const axiosInstance = axios.create(); // Axios instance for 401 redirection

axios.defaults.withCredentials = true;
axiosInstance.defaults.withCredentials = true;

const authInterceptor = response => response;
const errorHandler = error => {
  const { status } = error.response;
  if (status === 401) {
    document.location = '/';
  }
  return Promise.reject(error);
};

axiosInstance.interceptors.response.use(authInterceptor, errorHandler);

/**
 * Get Auth data
 *
 * @returns {Promise}
 */
const isLoggedIn = () => axios.get(`${apiUrl}/auth/test`);


/**
 * @param {String} email
 * @param {String} password
 *
 * @returns {Promise}
 */
const login = (email, password) => axios.post(`${apiUrl}/auth/login/`, { email, password });

/**
 * Logout 
 *
 * @returns {Promise}
 */
const logout = () => axios.post(`${apiUrl}/auth/logout/`);


/**
 *
 * @param {String} name
 * @param {String} email
 * @param {String} password
 */
const signUp = (name, email, password) => axios.post(`${apiUrl}/auth/register`, { name, email, password });


/**
 * Get user data
 *
 * @returns {Promise}
 */
const getUserData = () => axiosInstance.get(`${apiUrl}/auth/test`);


/**
 * Get all Job applications
 *
 * @returns {Promise}
 */
const getJobApplications = () => axiosInstance.get(`${apiUrl}/applications`);


/**
 * Update JOB application status
 *
 * @param {String} id
 * @param {String} status
 */
const updateApplicationStatus = (id, status) => axiosInstance.put(`${apiUrl}/applications/${id}`, { status });


/**
 * Delete JOB application
 *
 * @param {String} id
 */
const deleteApplication = id => axiosInstance.delete(`${apiUrl}/applications/${id}`);


/**
 * Add new Job application
 *
 * @param {String} title
 * @param {String} status
 * @param {Number} priority
 * @param {String} companyName
 *
 * @returns {Promise}
 */
const addJobApplication = (title, status, priority, company, url, location) => {
  const resolvedLocation = location === undefined ? url : location;
  const resolvedUrl = location === undefined ? '' : url;

  return axiosInstance.post(`${apiUrl}/applications`, {
    title,
    status,
    priority,
    company,
    url: resolvedUrl,
    location: resolvedLocation,
  });
};


/**
 * Get all subscriptions
 *
 * @returns {Promise}
 */
const getSubscriptions = () => axiosInstance.get(`${apiUrl}/subscriptions`);


/**
 * Update subscription status
 *
 * @param {String} id
 * @param {String} status
 */
const updateSubscriptionType = (id, type) => axiosInstance.put(`${apiUrl}/subscriptions/${id}`, { type });


/**
 * Delete subscription
 *
 * @param {String} id
 */
const deleteSubscription = id => axiosInstance.delete(`${apiUrl}/subscriptions/${id}`);


/**
 * Add new Subscription
 *
 * @param {String} title
 * @param {String} note
 * @param {String} companyName
 *
 * @returns {Promise}
 */
const addSubscription = ( type, note, time) => {
  return axiosInstance.post(`${apiUrl}/subscriptions`, {
    type,
    note,
    time,
  });
};



/**
 * Add new Job application
 *
 * @param {String} title
 * @param {object} jobDetail
 *
 * @returns {Promise}
 */
const updateJobApplication = (applicationId, jobDetail) => {
  return axiosInstance.put(`${apiUrl}/applications/${applicationId}`, jobDetail);
};

/**
 * Get Job Application detail
 *
 * @param {String} applicationId
 *
 * @returns {Promise}
 */
const getApplicationDetails = (applicationId) => axiosInstance.get(`${apiUrl}/applications/${applicationId}`);

/**
 * Get data dump
 *
 * @param {String} userId
 *
 * @returns {Promise}
 */
const getDataDump = (userId) => axiosInstance.get(`${apiUrl}/users/${userId}/data`);


/**
 * @param {String} applicationId
 * @param {String} title
 * @param {String} content
 *
 * @returns {Promise}
 */
const addNotes = (applicationId, title, content) => {
  return axiosInstance.post(`${apiUrl}/applications/${applicationId}/notes`, { title, content });
};


/**
 * @param {String} applicationId
 * @param {String} title
 * @param {String} content
 *
 * @returns {Promise}
 */
const updateNote = (applicationId, noteId, title, content) => {
  return axiosInstance.put(`${apiUrl}/applications/${applicationId}/notes/${noteId}`, { title, content });
};


/**
 * @param {String} applicationId
 * @param {String} noteId
 *
 * @returns {Promise}
 */
const deleteNote = (applicationId, noteId) => {
  return axiosInstance.delete(`${apiUrl}/applications/${applicationId}/notes/${noteId}`);
};


/**
 * @param {String} applicationId
 * @param {String} type
 * @param {String} note
 * @param {String} time
 *
 * @returns {Promise}
 */
const addTimeLog = (applicationId, type, time, note) => {
  return axiosInstance.post(`${apiUrl}/applications/${applicationId}/timelogs`, {
    type,
    time,
    note,
  });
};


/**
 * @param {String} applicationId
 * @param {String} timeLogId
 * @param {String} type
 * @param {String} note
 * @param {String} time
 *
 * @returns {Promise}
 */
const updateTimeLog = (applicationId, timeLogId, type, time, note) => {
  return axiosInstance.put(`${apiUrl}/applications/${applicationId}/timelogs/${timeLogId}`, {
    type,
    time,
    note,
  });
};


/**
 * @param {String} applicationId
 * @param {String} timeLogId
 *
 * @returns {Promise}
 */
const deleteTimeLog = (applicationId, timeLogId) => {
  return axiosInstance.delete(`${apiUrl}/applications/${applicationId}/timelogs/${timeLogId}`);
};


/**
 * @returns {Promise}
 */
const resendVerificationMail = () => axiosInstance.get(`${apiUrl}/auth/resend`);
const sendContactMail = (msg) => axiosInstance.get(`${apiUrl}/auth/contact?msg=${encodeURI(msg)}`);


/**
 * @param {String} currentPassword
 * @param {String} password
 *
 * @returns {Promise}
 */
const changePassword = (currentPassword, password) => {
  return axiosInstance.post(`${apiUrl}/auth/change`, {
    current_password: currentPassword,
    password,
  });
};

const changePremium = (email, premium) => {
  return axiosInstance.post(`${apiUrl}/auth/changeprem`, {
    email,
    premium,
  });
};

/**
 * @param {String} email
 *
 * @returns {Promise}
 */
const generateOTP = email => axiosInstance.post(`${apiUrl}/auth/generateotp`, { email });


/**
 * @param {String} email
 * @param {String} otp
 * @param {String} password
 *
 * @returns {Promise}
 */
const verifyOTP = (email, otp, password) => {
  return axiosInstance.post(`${apiUrl}/auth/verifyotp`, {
    email,
    otp,
    password,
  });
};


/**
 * @returns {Promise}
 */
const getPitch = () => axiosInstance.get(`${apiUrl}/pitch`);


/**
 * @param {String} pitch
 *
 * @returns {Promise}
 */
const updatePitch = (pitch) => axiosInstance.post(`${apiUrl}/pitch`, { pitch });


/**
 * @returns {Promise}
 */
const getLinkedins = () => axiosInstance.get(`${apiUrl}/linkedins`);


/**
 * @param {String} title
 * @param {String} content
 *
 * @returns {Promise}
 */
const addLinkedin = (name, content, hardskill, softskill, fullresponse) => axiosInstance.post(`${apiUrl}/linkedins`, { name, content, hardskill, softskill, fullresponse });


/**
 * @param {String} title
 * @param {String} content
 *
 * @returns {Promise}
 */
const updateLinkedin = (linkedinId, name, content, hardskill, softskill, fullresponse) => {
  return axiosInstance.put(`${apiUrl}/linkedins/${linkedinId}`, { name, content, hardskill, softskill, fullresponse });
};

 const getAlarms = () => axiosInstance.get(`${apiUrl}/alarms`);
 const getAlarmall = () => axiosInstance.get(`${apiUrl}/alarmall`);


 /**
  * @param {String} title
  * @param {String} email
  *
  * @returns {Promise}
  */
 const addAlarm = (name, email, title, hardskill, softskill, filtr) => axiosInstance.post(`${apiUrl}/alarms`, { name, email, title, hardskill, softskill, filtr });


 /**
  * @param {String} title
  * @param {String} email
  *
  * @returns {Promise}
  */
 const updateAlarm = (alarmId, name, email, title, hardskill, softskill, filtr) => {
   return axiosInstance.put(`${apiUrl}/alarms/${alarmId}`, { name, email, title, hardskill, softskill, filtr });
 };


 /**
  * @param {String} alarmId
  *
  * @returns {Promise}
  */
 const deleteAlarm = (alarmId) => axiosInstance.delete(`${apiUrl}/alarms/${alarmId}`);


 /**
  * @returns {Promise}
  */
/**
 * @param {String} linkedinId
 *
 * @returns {Promise}
 */
const deleteLinkedin = (linkedinId) => axiosInstance.delete(`${apiUrl}/linkedins/${linkedinId}`);

/**
 * @returns {Promise}
 */
const getResumes = () => axiosInstance.get(`${apiUrl}/resumes`);


/**
 * @param {String} title
 * @param {String} content
 *
 * @returns {Promise}
 */
const addResume = (name, content, hardskill, softskill, shardskill, ssoftskill, fullresponse) => axiosInstance.post(`${apiUrl}/resumes`, { name, content, hardskill, softskill, shardskill, ssoftskill, fullresponse });


/**
 * @param {String} title
 * @param {String} content
 *
 * @returns {Promise}
 */
const updateResume = (resumeId, name, content, hardskill, softskill, shardskill, ssoftskill, fullresponse) => {
  return axiosInstance.put(`${apiUrl}/resumes/${resumeId}`, { name, content, hardskill, softskill, shardskill, ssoftskill, fullresponse });
};


/**
 * @param {String} resumeId
 *
 * @returns {Promise}
 */
const deleteResume = (resumeId) => axiosInstance.delete(`${apiUrl}/resumes/${resumeId}`);


/**
 * @returns {Promise}
 */
const getTanalyses = () => axiosInstance.get(`${apiUrl}/tanalyses`);

/**
 * @param {String} title
 * @param {String} content
 *
 * @returns {Promise}
 */
const addTanalysis = (title, content) => axiosInstance.post(`${apiUrl}/tanalyses`, { title, content });


/**
 * @param {String} title
 * @param {String} content
 *
 * @returns {Promise}
 */
const updateTanalysis = (tanalysisId, title, content) => {
  return axiosInstance.put(`${apiUrl}/tanalyses/${tanalysisId}`, { title, content });
};


/**
 * @param {String} tanalysisId
 *
 * @returns {Promise}
 */
const deleteTanalysis = (tanalysisId) => axiosInstance.delete(`${apiUrl}/tanalyses/${tanalysisId}`);


/**
 * @returns {Promise}
 */
const getAnalyses = () => axiosInstance.get(`${apiUrl}/analyses`);


/**
 * @param {String} title
 * @param {String} content
 *
 * @returns {Promise}
 */
const addAnalysis = (title, content) => axiosInstance.post(`${apiUrl}/analyses`, { title, content });


/**
 * @param {String} title
 * @param {String} content
 *
 * @returns {Promise}
 */
const updateAnalysis = (analysisId, title, content) => {
  return axiosInstance.put(`${apiUrl}/analyses/${analysisId}`, { title, content });
};


/**
 * @param {String} analysisId
 *
 * @returns {Promise}
 */
const deleteAnalysis = (analysisId) => axiosInstance.delete(`${apiUrl}/analyses/${analysisId}`);

export default {
  isLoggedIn,
  login,
  signUp,
  getUserData,
  getJobApplications,
  updateApplicationStatus,
  getSubscriptions,
  updateSubscriptionType,
  changePremium,
  deleteApplication,
  addJobApplication,
  deleteSubscription,
  addSubscription,
  updateJobApplication,
  getApplicationDetails,
  logout,
  addNotes,
  deleteNote,
  updateNote,
  resendVerificationMail,
  sendContactMail,
  changePassword,
  generateOTP,
  verifyOTP,
  addTimeLog,
  deleteTimeLog,
  updateTimeLog,
  getPitch,
  updatePitch,
  getLinkedins,
  addLinkedin,
  updateLinkedin,
  deleteLinkedin,
  getTanalyses,
  addTanalysis,
  updateTanalysis,
  deleteTanalysis,
  getResumes,
  addResume,
  updateResume,
  deleteResume,
  getAnalyses,
  addAnalysis,
  updateAnalysis,
  deleteAnalysis,
  getDataDump,
  getAlarmall,
  getAlarms,
  addAlarm,
  updateAlarm,
  deleteAlarm,
};
